import moment from 'moment';
import { mapGetters } from 'vuex';
import Console from '../shared/console';

export default {
  computed: {
    ...mapGetters({
      userDateFormat: 'userDateFormat',
      backendDateFormat: 'backendDateFormat',
    }),
  },

  methods: {
    getDateInUserFormat(date) {
      let usedFormat;
      if (!this.userDateFormat) {
        usedFormat = this.backendDateFormat;
        Console.warn('No user format when trying to format a date');
      } else {
        usedFormat = this.userDateFormat;
      }
      return moment(date).format(usedFormat);
    },

    getDateWithoutTimeZoneInUserFormat(date) {
      let usedFormat;
      if (date?.includes('T')) {
        date = date.split('T')[0];
      }

      if (!this.userDateFormat) {
        usedFormat = this.backendDateFormat;
        Console.warn('No user format when trying to format a date');
      } else {
        usedFormat = this.userDateFormat;
      }
      return date ? moment(date).format(usedFormat) : '';
    },

    getDateTimeInUserFormat(date) {
      let usedFormat;
      if (!this.userDateFormat) {
        usedFormat = this.backendDateFormat;
        Console.warn('No user format when trying to format a date');
      } else {
        usedFormat = this.userDateFormat;
      }
      return moment(date).format(`${usedFormat} hh:mm a `);
    },

    getDateInBackendDateFormat(date) {
      let dateFormattedToUserFormat = date;

      if (this.userDateFormat) {
        dateFormattedToUserFormat = moment(date).format(this.userDateFormat);
      }

      const fullDate = moment(dateFormattedToUserFormat, [this.userDateFormat ? this.userDateFormat : '', this.backendDateFormat]);
      if (fullDate.isValid()) {
        return fullDate.format(this.backendDateFormat);
      } else {
        return null;
      }
    },

    getDateInBackFormatAlways(date) {
      return moment(date, [this.userDateFormat ? this.userDateFormat : '', this.backendDateFormat]).format(this.backendDateFormat);
    },

    getFormattedTime(date, timeFormat = 'hh:mm:ss') {
      const formattedDate = moment(date);

      if (!formattedDate.isValid()) {
        return;
      }

      return formattedDate.format(timeFormat);
    },

    formatDateToUserFormatAndTime(date) {
      const usersDate = this.getDateInUserFormat(date);
      const time = this.getFormattedTime(date);
      return `${usersDate} ${time}`;
    },
  },
};
